<style lang="scss">
	#areasimple {
		.lineChart {
			width: 100%;
			height: 350px;
			display: inline-block;
			// background-color: #1e094e;
			// box-shadow: 0 2px 12px 0 rgba(30,9,78, 1);
		}
	}
</style>

<template>
	<div id='areasimple'>
		<div class="lineChart Chart" :id="useData.id"></div>
	</div>
</template>
<script>
	export default {
		name: 'lineChart',
		props: ['dataBol', 'useData', 'widthPxMess'],
		data() {
			return {

			}
		},
		watch: {
			'dataBol': {
				immediate:true,
				handler(n) {
					let _this = this;
					if (n) {
						let myChart = _this.$echarts.init(document.getElementById(_this.useData.id));
						_this.myChart = myChart;
						_this.drawChart();
					}
				}
			}
		},
		methods: {
			drawChart() {
				let _this = this;
				let stk =_this.useData.datearrs['data-x'].length > 8 ? [{
						type: 'inside',
						start: 0,
						end: 30
					}, {
						start: 0,
						end: 30
					}] :[];
					console.log(stk)
				_this.myChart.setOption({
					tooltip: {
						trigger: 'axis', //axis
						position: function(pt) {
							return [pt[0], '20%'];
						},
						formatter: params => {
							let cstr = ''
							params.map(ev => {
								cstr +=`<div style='display:flex;flex-direction: row;'><div style='width:2.2rem;fontSize:1rem'>`
								+ev.seriesName+`</div>`+ ' ： ' + ev.value+`</div>`
							})
							//可以在此设置每一条数据的hover提示信息，根据params.data中的数据自己判断，然后返回不同的值
							return cstr;
						},
						axisPointer: {
							animation: false
						}
					},
					// title:{
					//     text:' ',//_this.useData.title
					//     textStyle:{
					//         color: '#ffffff',
					//         fontWeight: 'bold',
					//         fontSize:_this.widthPxMess.titleSize,
					//     },
					//     x:'center',
					//     y:'20',
					// },
					grid: {
						// top:'25%',
						x: 40,
						y: 60,
						x2: 45,
						y2: 65,
						borderWidth: 10
					},
					animation: true,
					xAxis: {
						name: '時間',
						type: 'category',
						data: _this.useData.datearrs['data-x'], //[1,2,3,5,6,4,78,2,3,5,6,4,78],//_this.useData.x
						boundaryGap: false,
						// axisTick:{
						//     show:false,
						// },
						nameTextStyle: {
							padding: [30, -20, 30, 0], // 四个数字分别为上右下左与原位置距离
							fontSize: 15,
							color: '#666'
						},
						axisLine: {
							// show:false,
							lineStyle: {
								color: '#ccc'
							}
						},
						axisLabel: {
							color: '#666',
							// interval:0,
							// fontSize:_this.widthPxMess.XYSize
						}
					},
					dataZoom: stk,
					// toolbox: {
					// 	feature: {
					// 		dataZoom: {
					// 			yAxisIndex: 'none'
					// 		},
					// 		restore: {},
					// 		saveAsImage: {}
					// 	}
					// },
					yAxis: {
						data: _this.useData.datearrs['data-y'], //[1,2,3,5,6,9,18],//_this.useData.x
						type: 'value',
						// boundaryGap: [0, '100%']
						name: _this.useData.ccy,
						nameTextStyle: {
							padding: [60, 50, 20, 0], // 四个数字分别为上右下左与原位置距离
							fontSize: 15,
							color: '#666'
						},
						// axisTick:{
						//     show:false,
						// },
						splitLine: {
							show: true,
							lineStyle: {
								color: '#ccc',
								type: 'dashed'
							}
						},
						axisLine: {
							show: false,
							lineStyle: {
								color: '#ccc',
							}
						},
						axisLabel: {
							// fontSize:_this.widthPxMess.XYSize
							color: '#666',
						},
						// minInterval:1,
					},

					series: [
						// {
						//        name: '模拟数据',
						//        type: 'line',
						//        showSymbol: false,
						//        hoverAnimation: false,
						// 	   // xAxisIndex: 1,
						// 	   // yAxisIndex: 1,
						//        data: [10,9,8,15,16,14,18,12,13,15,16,14,18]
						//    },
						{
							name: '盈  利', //參考價
							type: 'line',
							showSymbol: false,
							hoverAnimation: false,
							symbol: 'none',
							sampling: 'lttb',
							itemStyle: {
								color: '#ff5003'
							},
							areaStyle: {
								color: new _this.$echarts.graphic.LinearGradient(0, 0, 0, 1,
									[{
										offset: 0,
										color: 'rgba(255, 158, 68,20)'
									}, {
										offset: 1,
										color: 'rgba(255, 70, 131,0)'
									}]
								)
							},
							data: this.useData.plr, //[11,12,13,15,16,14,18,12,13,15,16,14,18]
						},
						{
							name: '参考價',
							type: 'line',
							symbol: 'none',
							sampling: 'lttb',
							itemStyle: {
								color: 'transparent'
							},
							data: this.useData.avgpricearr
						},
						{
							name: '平均價',
							type: 'line',
							symbol: 'none',
							sampling: 'lttb',
							itemStyle: {
								color: 'transparent'
							},
							data: this.useData.price
						},
						{
							name: '總股數',
							type: 'line',
							symbol: 'none',
							sampling: 'lttb',
							itemStyle: {
								color: 'transparent'
							},
							data: this.useData.qty
						},
						// {
						//         type: 'line',
						//         showSymbol: false,
						//         data: [1,2,3,5,6,4,78,2,3,5,6,4,78]
						//     }, {
						//         type: 'line',
						//         showSymbol: false,
						//         data: [1,2,3,5,6,4,78,2,3,5,6,4,78],
						//         xAxisIndex: 1,
						//         yAxisIndex: 1
						//     }
					],
				})
			}
		}
	}
</script>
